/* eslint-disable no-unused-vars, no-useless-constructor*/
import React from 'react';
import BaseComponent from '../../../../../panther/components/base/BaseComponent';
import PropTypes from 'prop-types';
import {Fade} from 'react-reveal';

import classNames from 'classnames';

import styles from './MicrositeSectionTitle.css';

class MicrositeSectionTitle extends BaseComponent {
    constructor() {
        super();
    }

    render() {
        let title = this.renderTitle();
        let divider = null;
        if (this.props.divider){
            divider = this.renderDivider();
        }

        return (
            <Fade>
                <div className="microsite-section-header">
                    {title}
                    {divider}
                </div>
            </Fade>
        );
    }

    /**
     * Render section title
     * @returns {XML}
     */
    renderTitle(){
        let classes = classNames(
            'microsite-section-title',
            {
                'light': this.props.light,
                'centered': this.props.centered
            },
            this.props.className
        );

        return (
            <h2 className={classes}>
                {this.props.name}
            </h2>
        );
    }

    /**
     * Render divider between title and rest of the section
     * @returns {XML}
     */
    renderDivider(){
        let classes = classNames(
            'microsite-section-divider',
            {
                'light': !this.props.light,
                'centered': this.props.centered
            },
            this.props.className
        );

        return (<hr className={classes}/>);
    }
}

MicrositeSectionTitle.propTypes = {
    centered: PropTypes.bool,
    divider: PropTypes.bool,
    light: PropTypes.bool,
    name: PropTypes.string
};

export default MicrositeSectionTitle;